import { Typography } from '@euler/app/components/typography';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, ReactNode } from 'react';
import { StyleProp, View, ViewProps, ViewStyle } from 'react-native';

export const OrderPreviewSection = memo(
  ({
    title,
    children,
    headerRight,
    ...props
  }: ViewProps & { title: string; headerRight?: ReactNode }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        css={`
          margin-bottom: ${rpx(10)}px;
        `}
        {...props}
      >
        <Header title={title}>{headerRight}</Header>
        {children}
      </View>
    );
  },
);

const Header = memo(
  ({
    title,
    style,
    children,
  }: {
    title: string;
    style?: StyleProp<ViewStyle>;
    children?: ReactNode;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <HStack
        css={`
          padding: ${rpx(10)}px;
          border-bottom-width: 1px;
          border-bottom-color: rgb(241, 241, 241);
        `}
        style={style}
      >
        <View
          css={`
            justify-content: center;
          `}
        >
          <View
            css={`
              position: absolute;
              background-color: rgba(32, 127, 231, 0.33);
              height: ${rpx(9)}px;
              border-radius: ${rpx(9) / 2}px;
              left: 0;
              right: 0;
              bottom: 0;
            `}
          />
          <Typography.Label
            bold
            size={rpx(20)}
            color="rgb(32, 127, 231)"
            css={`
              margin: 0 ${rpx(8)}px;
            `}
          >
            {title}
          </Typography.Label>
        </View>
        <View
          css={`
            padding-right: ${rpx(10)}px;
          `}
        >
          {children}
        </View>
      </HStack>
    );
  },
);
